import { Box, Typography } from '@mui/material'
import {
  ADMIN_PASSWORD_REQUIREMENT_ITEMS,
  evaluateAdminPasswordPolicy,
} from '../utils/adminPasswordPolicy'

/**
 * Live checklist for admin password policy requirements.
 */
const AdminPasswordRequirements = ({ password, dark = false }) => {
  const checks = evaluateAdminPasswordPolicy(password)
  const muted = dark ? 'rgba(255,255,255,0.55)' : 'text.secondary'
  const ok = dark ? '#81c784' : 'success.main'

  return (
    <Box component="ul" sx={{ m: 0, mb: 2.5, pl: 2.5 }}>
      {ADMIN_PASSWORD_REQUIREMENT_ITEMS.map((item) => {
        const passed = Boolean(checks[item.key])
        return (
          <Typography
            key={item.key}
            component="li"
            variant="body2"
            sx={{
              // Met = green; unmet stays muted (matches invite/reset dark UI)
              color: passed ? ok : muted,
              listStyleType: '"✓ "',
              mb: 0.35,
            }}
          >
            {item.label}
          </Typography>
        )
      })}
    </Box>
  )
}

export default AdminPasswordRequirements
